import { Component, Input, OnInit } from '@angular/core';
import { UrlData } from 'src/app/pages/main/module/model/url-data';
import { SignData } from 'src/app/pages/main/module/engineering-application/components/model/SignData';
import { CommonService } from '../../../service/common/common.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-listitem',
  templateUrl: './listitem.component.html',
  styleUrls: ['./listitem.component.scss']
})
export class ListitemComponent implements OnInit {
  @Input() listItem: SignData;
  @Input() url: UrlData | undefined
  @Input() activeBtn: string;
  @Input() step: number;
  // 创建主题对象,改对象内部维护订阅当前主题的观察者数组
  destroy$ = new Subject();

  version = ""
  userid: string;
  constructor(
    private commonService: CommonService,
    private translateService: TranslateService
  ) {
    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(lang => {
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.userid = localStorage.getItem('userid');
    // 多国语言时间
    const lan = localStorage.getItem('language');
    this.listItem['applicant']['applayTime']=this.commonService.switchDateLanguage(this.listItem['applicant']['applayTime']);
    this.version = lan === "en_US" ? `Version ${this.listItem['applicant']['version']}` : `第${this.listItem['applicant']['version']}版`
  }

  // 进入单据详情页面
  async detailData() {
    await this.commonService.detailData(this.listItem['applicant']['formid'], this.url, this.activeBtn, this.step, this.userid,this.url.name);
  }
}
